import { pageConfig } from '@/common/service/page-config';

export const isFromZeConsumption = () => {
  return /^(zecc_yearly|zeca_yearly)(\d+)?$/i.test(pageConfig?.from || pageConfig?.from_sub);
};
